export default function Header() {
  return (
    <div className="header">
      <h1>
        Hey there, I’m Ivy - a product designer and 3D illustrator from San
        Francisco Bay Area, currently based in Taipei, Taiwan ✿ Intrigued by
        graphics that tell stories{" "}
      </h1>
    </div>
  );
}
